import React from 'react';

// Helper function to format location data
const formatLocation = (location) => {
  if (!location) return 'Not specified';
  
  // If location is a string, return it directly
  if (typeof location === 'string') return location;
  
  // If location is an object with longitude, latitude, description
  if (typeof location === 'object') {
    const parts = [];
    if (location.description) parts.push(location.description);
    if (location.latitude && location.longitude) {
      parts.push(`(${location.latitude}, ${location.longitude})`);
    }
    return parts.length > 0 ? parts.join(' ') : 'Not specified';
  }
  
  return 'Not specified';
};

const ProjectDetails = ({ project }) => {
  if (!project) {
    return <div>No project data available</div>;
  }

  const details = [
    {
      icon: '🏗️',
      title: 'Project Name',
      content: project.project_name,
      key: 'project_name'
    },
    {
      icon: '📍',
      title: 'Location',
      content: formatLocation(project.location),
      key: 'location'
    },
    {
      icon: '🏢',
      title: 'Facilities',
      content: project.facilities,
      key: 'facilities'
    },
    {
      icon: '📋',
      title: 'Project Summary',
      content: project.summary,
      key: 'summary'
    },
    {
      icon: '📐',
      title: 'Average Area',
      content: project.average_area,
      key: 'average_area'
    },
    {
      icon: '💰',
      title: 'Payment Plans',
      content: project.payment_plans,
      key: 'payment_plans'
    }
  ];

  return (
    <div className="project-details">
      {project.source_file && project.source_file !== 'Unknown' && (
        <div className="source-file-info">
          📄 Source: {project.source_file}
        </div>
      )}
      
      {details.map((detail) => (
        <div key={detail.key} className="detail-item">
          <h3>{detail.icon} {detail.title}</h3>
          <p>{detail.content || 'Not specified'}</p>
        </div>
      ))}
    </div>
  );
};

export default ProjectDetails;
